import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import Service from "@/services/KepatuhanIdentifikasiPasienService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "kepatuhan-identifikasi-pasien"
})
class KepatuhanIdentifikasiPasienModule extends VuexModule {
  // --- State ---
  sessions: any[] = [];
  currentSession: any = null;
  dashboard: any = null;
  loading = false;
  pagination = {
    currentPage: 1,
    lastPage: 1,
    perPage: 20,
    total: 0
  };
  filters: any = {
    bulan: new Date().getMonth() + 1,
    tahun: new Date().getFullYear(),
    unit_ruangan: "",
    shift: "",
    momen: "",
    kategori_kepatuhan: "",
    ada_ktd: "",
    status: "",
    status_target: "",
    tanggal: "",
    search: ""
  };

  // --- Mutations ---
  @Mutation SET_SESSIONS(val: any[]) { this.sessions = val; }
  @Mutation SET_CURRENT_SESSION(val: any) { this.currentSession = val; }
  @Mutation SET_DASHBOARD(val: any) { this.dashboard = val; }
  @Mutation SET_LOADING(val: boolean) { this.loading = val; }
  @Mutation SET_PAGINATION(val: any) { this.pagination = val; }
  @Mutation SET_FILTERS(val: any) { this.filters = { ...this.filters, ...val }; }

  // --- Actions ---

  @Action
  async loadSessions(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await Service.getSessions(params);
      const resp = dt.data;
      this.SET_SESSIONS(resp.data?.data || resp.data || []);
      if (resp.meta) {
        this.SET_PAGINATION({
          currentPage: resp.meta.current_page,
          lastPage: resp.meta.last_page,
          perPage: resp.meta.per_page,
          total: resp.meta.total
        });
      }
    } catch (e) {
      console.error("loadSessions error:", e);
    }
    this.SET_LOADING(false);
  }

  @Action
  async loadSession(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await Service.getSession(id);
      this.SET_CURRENT_SESSION(dt.data.data || null);
    } catch (e) {
      console.error("loadSession error:", e);
    }
    this.SET_LOADING(false);
  }

  @Action
  async createSession(data: any) {
    const dt = await Service.createSession(data);
    return dt.data.data || dt.data;
  }

  @Action
  async updateSession(payload: { id: number; data: any }) {
    const dt = await Service.updateSession(payload.id, payload.data);
    return dt.data.data || dt.data;
  }

  @Action
  async deleteSession(id: number) {
    await Service.deleteSession(id);
  }

  @Action
  async addObservation(payload: { sessionId: number; data: any }) {
    const dt = await Service.addObservation(payload.sessionId, payload.data);
    return dt.data.data || dt.data;
  }

  @Action
  async updateObservation(payload: { sessionId: number; obsId: number; data: any }) {
    const dt = await Service.updateObservation(payload.sessionId, payload.obsId, payload.data);
    return dt.data.data || dt.data;
  }

  @Action
  async deleteObservation(payload: { sessionId: number; obsId: number }) {
    await Service.deleteObservation(payload.sessionId, payload.obsId);
  }

  @Action
  async addRtl(payload: { sessionId: number; data: any }) {
    const dt = await Service.addRtl(payload.sessionId, payload.data);
    return dt.data.data || dt.data;
  }

  @Action
  async updateRtl(payload: { sessionId: number; rtlId: number; data: any }) {
    const dt = await Service.updateRtl(payload.sessionId, payload.rtlId, payload.data);
    return dt.data.data || dt.data;
  }

  @Action
  async deleteRtl(payload: { sessionId: number; rtlId: number }) {
    await Service.deleteRtl(payload.sessionId, payload.rtlId);
  }

  @Action
  async addKtdEvent(payload: { sessionId: number; data: any }) {
    const dt = await Service.addKtdEvent(payload.sessionId, payload.data);
    return dt.data.data || dt.data;
  }

  @Action
  async updateKtdEvent(payload: { sessionId: number; ktdId: number; data: any }) {
    const dt = await Service.updateKtdEvent(payload.sessionId, payload.ktdId, payload.data);
    return dt.data.data || dt.data;
  }

  @Action
  async deleteKtdEvent(payload: { sessionId: number; ktdId: number }) {
    await Service.deleteKtdEvent(payload.sessionId, payload.ktdId);
  }

  @Action
  async signPencatat(payload: { id: number; password: string }) {
    const dt = await Service.signPencatat(payload.id, payload.password);
    this.SET_CURRENT_SESSION(dt.data.data || null);
    return dt.data.data;
  }

  @Action
  async signVerifikator(payload: { id: number; password: string }) {
    const dt = await Service.signVerifikator(payload.id, payload.password);
    this.SET_CURRENT_SESSION(dt.data.data || null);
    return dt.data.data;
  }

  @Action
  async signKepalaUnit(payload: { id: number; password: string }) {
    const dt = await Service.signKepalaUnit(payload.id, payload.password);
    this.SET_CURRENT_SESSION(dt.data.data || null);
    return dt.data.data;
  }

  @Action
  async loadDashboard(params: any) {
    try {
      const dt = await Service.getDashboard(params);
      this.SET_DASHBOARD(dt.data.data || null);
    } catch (e) {
      console.error("loadDashboard error:", e);
    }
  }

  @Action
  setFilters(filters: any) {
    this.SET_FILTERS(filters);
  }
}

export default getModule(KepatuhanIdentifikasiPasienModule);
